import Axios from "./index";

export const addRss = rss => {
  return Axios.post(`/user/rss`, rss);
};
